import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { useUserRamps } from "./components/PaletteEditor";
import { Loading, ToastHost } from "./components/ui";
import Login from "./screens/Login";
import PrintCPI from "./screens/PrintCPI";
import PrintCPIMulti from "./screens/PrintCPIMulti";
import Projects from "./screens/Projects";
import Workspace from "./screens/Workspace";

export default function App() {
  const { user, loading } = useAuth();
  // Palet buatan pengguna didaftarkan di akar, bukan di layar yang
  // menyuntingnya: yang memerlukannya adalah setiap layar yang menggambar pita
  // warna — termasuk lembar cetak, yang tidak punya rel dan tidak pernah
  // membuka penyuntingnya. Didaftarkan sekali di sini, sebuah palet rumah
  // sudah berlaku di mana pun ia dipilih.
  useUserRamps();

  if (loading) {
    return (
      <div style={{ display: "grid", placeItems: "center", height: "100%" }}>
        <Loading label="Preparing the session…" />
      </div>
    );
  }

  if (!user) {
    return (
      <ToastHost>
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      </ToastHost>
    );
  }

  return (
    <ToastHost>
      <Routes>
        <Route path="/" element={<Navigate to="/projects" replace />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectId/dashboard" element={<Workspace screen="dashboard" />} />
        <Route path="/projects/:projectId/log" element={<Workspace screen="log" />} />
        <Route path="/projects/:projectId/crossplot" element={<Workspace screen="crossplot" />} />
        <Route path="/projects/:projectId/histogram" element={<Workspace screen="histogram" />} />
        <Route path="/projects/:projectId/correlation" element={<Workspace screen="correlation" />} />
        <Route path="/projects/:projectId/map" element={<Workspace screen="map" />} />
        <Route path="/projects/:projectId/analysis" element={<Workspace screen="analysis" />} />
        <Route path="/projects/:projectId/geomodel" element={<Workspace screen="geomodel" />} />
        <Route path="/projects/:projectId/estimate" element={<Workspace screen="estimate" />} />
        <Route path="/projects/:projectId/lrlc" element={<Workspace screen="lrlc" />} />
        <Route path="/projects/:projectId/image" element={<Workspace screen="image" />} />
        <Route path="/projects/:projectId/core" element={<Workspace screen="core" />} />
        {/* Berkas banyak sumur berdiri lebih dulu: tanpa `id` jalurnya akan
            tertelan pola satu sumur dan "cpi" dibaca sebagai nomor sumur. */}
        <Route path="/projects/:id/print/cpi" element={<PrintCPIMulti />} />
        <Route path="/print/cpi/:wellId" element={<PrintCPI />} />
        <Route path="*" element={<Navigate to="/projects" replace />} />
      </Routes>
    </ToastHost>
  );
}
